import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { height: Number }

  connect() {
    this.resize = this.resize.bind(this)
    this.observer = new ResizeObserver(this.resize)
    this.observer.observe(this.element.parentElement)
    const header = document.querySelector(".header")
    if (header) this.observer.observe(header)
    document.querySelectorAll('[data-portal-toolbar]').forEach(toolbar => this.observer.observe(toolbar))
    window.addEventListener("resize", this.resize)
    this.resize()
  }

  disconnect() {
    this.observer.disconnect()
    window.removeEventListener("resize", this.resize)
  }

  resize() {
    // Keep the bottom scrollbar inside the viewport, regardless of sidebar size.
    const top = this.element.getBoundingClientRect().top + window.scrollY
    const height = this.hasHeightValue
      ? this.heightValue
      : Math.max(0, Math.floor(document.documentElement.clientHeight - top))
    this.element.style.height = `${height}px`
  }
}
